import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";

// دالة جديدة لاسترجاع جميع الصفحات
export const fetchPages = createAsyncThunk(
  "pages/fetchPages", // اسم الأكشن الذي سيكون فريدًا
  async (_, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await request.get(`https://ssl.vipwellness-suite.de/api/pages`);
      console.log("API Response !:", res.data); 
      return res.data.pages; // تأكد من استرجاع الصفحات فقط
      
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = { pages: [], loading: false, error: null };
const pagesSlice = createSlice({
  name: 'pages', // اسم السلايس الذي يعكس البيانات المتعلقة بالصفحات
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPages.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPages.fulfilled, (state, action) => {
      state.loading = false;
      console.log("Fetched pages:", action.payload);
      state.pages = action.payload || []; // حفظ البيانات المسترجعة
    });
    builder.addCase(fetchPages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export default pagesSlice.reducer;
